<style lang="css">
    @import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
    @import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";

    :root {
        --ag-header-background-color: #F0F3F6;
        --ag-header-foreground-color: #646E78;
        --ag-row-border-color: #E6EBF0;
        --ag-data-color: #1E2832;
        --ag-even-row-background-color: #FFFFFF;
        --ag-odd-row-background-color: #FFFFFF;
        --ag-row-hover-color: #F7F9FB;
        --ag-border-color: #F0F3F6;
    }

    .ag-theme-alpine {
        box-shadow: 0 10px 15px -6px rgb(0 20 40 / 35%) !important;
        font-family: montserrat, sans-serif !important;
    }

    .ag-header-cell-text {
        font-size: 12px !important;
        font-weight: 400 !important;
        text-transform: uppercase !important;
    }

    .ag-root-wrapper {
        border: none !important;
        overflow: visible !important;
    }

    .ag-header {
        border-bottom: none !important;
    }

    .ag-row {
        font-weight: 500 !important;
        font-size: 12px !important;
    }

    .ag-row .ag-cell {
        display: flex;
        align-items: center;
    }

    .ag-theme-alpine .ag-layout-auto-height .ag-center-cols-clipper, .ag-theme-alpine .ag-layout-auto-height .ag-center-cols-container, .ag-theme-alpine .ag-layout-print .ag-center-cols-clipper, .ag-theme-alpine .ag-layout-print .ag-center-cols-container {
        min-height: unset;
    }

    .ag-theme-alpine .ag-cell, .ag-theme-alpine .ag-full-width-row .ag-cell-wrapper.ag-row-group {
        line-height: unset;
    }

    .ag-theme-alpine .ag-cell span, .ag-theme-alpine .ag-full-width-row .ag-cell-wrapper.ag-row-group span {
        overflow-y: auto;
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .ag-watermark {
        display: none !important;
    }

    .ag-watermark {
        display: none !important;
    }

    .ag-center-cols-viewport {
        height: 100% !important;
        overflow-y: hidden !important;
        overflow-x: hidden !important;
    }

    .ag-cell span::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #E9EEF3;
    }

    .ag-cell span::-webkit-scrollbar-thumb {
        background: #D9E2EC;
    }

    .ag-menu {
        min-height: 5vh !important;
    }

    @media (max-width: 1024px) {
        .ag-header-cell-text {
            font-size: 10px !important;
            font-weight: 400 !important;
        }
        .ag-row {
            font-weight: 400 !important;
            font-size: 10px !important;
        }
    }

    @media (max-width: 1400px) {
        .ag-header-cell-text {
            font-size: 11px !important;
            font-weight: 500 !important;
        }
        .ag-row {
            font-weight: 500 !important;
            font-size: 11px !important;
        }
    }
</style>
<style scoped>
    .aggrid-container {
        width: 100%;
    }

    .aggrid-filter {
        margin-bottom: 25px;
        display: flex;
        justify-content: flex-end;
    }

    .aggrid-title {
        background-color: #0d3b70;
        color: white;
        margin-top: -30px;
        height: 30px;
        width: fit-content;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 20px;
        font-weight: 600;
        text-transform: uppercase;
        font-size: 12px;
    }

    .aggrid-title:after {
        position: absolute;
        right: -15px;
        top: 0;
        content: '';
        width: 0;
        height: 0;
        border-top: 30px solid transparent;
        border-bottom: 0 solid transparent;
        border-left: 15px solid #0d3b70;
    }
</style>

<template>
    <div class="aggrid-container" :style="cssProps">
        <div class="aggrid-filter">
            <slot name="filter"></slot>
        </div>
        <div v-if="title !== null" class="aggrid-title">{{ title }}</div>
        <ag-grid-vue style="width: 100%; max-height: calc(85vh - var(--aggrid-height-substract));" :style="aggridCssProps" class="ag-theme-alpine"
            :columnDefs="columnDefs"
            :frameworkComponents="frameworkComponents"
            :gridOptions="gridMergedOptions"
            @grid-ready="onGridReady"
            @row-clicked="onRowClicked"
            :context="context"
            :allowContextMenuWithControlKey="true"
            :getContextMenuItems="getContextMenuItems"
            @column-visible="onColumnVisible"
            @sort-changed="onSortChanged"
            @column-resized="onColumnResized"
        >
        </ag-grid-vue>
    </div>
</template>

<script>
  import {AgGridVue} from "ag-grid-vue3";
  import axios from 'axios';
  import $ from 'jquery';

  export default {
    name: 'Aggrid',
    props: {
        apiRoute: {
            type: String,
            default: ''
        },
        apiParams: {
            type: Object,
            default: null
        },
        columnDefs: {
            type: Array,
            default: null
        },
        rowData: {
            type: Array,
            default: null
        },
        frameworkComponents: {
            type: Object,
            default: null
        },
        gridOptions: {
            type: Object,
            default: null
        },
        context: {
            type: Object,
            default: null
        },
        title: {
            type: String,
            default: null
        },
        aggridHeightSubstract: {
            type: String,
            default: '30px'
        },
        exportName: {
            type: String,
            default: ''
        },
        cellRendererFunctions: {
            type: Object,
            default: new Map()
        },
        valueFormatterFunctions: {
            type: Object,
            default: new Map()
        },
        exportLimit: {
            type: Number,
            default: 10000
        },
        // Route alternative appelée uniquement pour l'export Excel.
        // Permet à un écran de servir l'export depuis une route allégée, sans traîner les
        // données dont seul l'affichage a besoin (compteurs, panneaux de détail...).
        // Si elle n'est pas renseignée, l'export passe par apiRoute comme avant.
        exportApiRoute: {
            type: String,
            default: null
        },
    },
    components: {
        AgGridVue
    },
    watch: {
        apiParams: {
            handler() {
                this.aggridApiParams = this.apiParams;
            },
            immediate: true,
            deep: true
        },
        aggridApiParams: {
            handler() {
                if (this.gridReady) {
                    if (JSON.stringify(this.aggridApiParams) != JSON.stringify(this.previousFilter)) {
                        this.previousFilter !== null && this.gridApi.refreshInfiniteCache();
                        this.previousFilter = JSON.parse(JSON.stringify(this.aggridApiParams));
                    }
                }
            },
            immediate: true,
            deep: true
        }
    },
    data() {
        return {
            paginationParams: {
                page: 1,
                numberItems: this.numberItems
            },
            gridMergedOptions: {},
            aggridApiParams: null,
            loaders: [],
            aggridCssProps: {
                height: '100px'
            },
            params: null,
            previousFilter: null
        }
    },
    computed: {
        cssProps() {
            return {
                '--aggrid-height-substract': this.aggridHeightSubstract,
            }
        }
    },
    beforeMount() {
        const that = this;
        this.gridMergedOptions = {
            paginationPageSize: this.numberItems,
            cacheBlockSize: this.numberItems,
            maxBlocksInCache: 1,
            suppressCellSelection: true,
            suppressMovableColumns: true,
            suppressHorizontalScroll: true,
            suppressPropertyNamesCheck: true,
            getRowNodeId: function (data) {
                return data.id;
            },
            defaultColDef: {
                filter: 'agTextColumnFilter', // Surcharger par agNumberColumnFilter ou agDateColumnFilter dans columnDefs si besoin
                resizable: true,
                sortable: false
            },
            animateRows: true,
            rowHeight: 70,
            rowBuffer: 0,
            rowSelection: 'multiple',
            rowModelType: 'infinite',
            cacheBlockSize: 20,
            cacheOverflowSize: 1,
            maxConcurrentDatasourceRequests: 3,
            infiniteInitialRowCount: 20,
            maxBlocksInCache: 20,
            localeText: {
                loadingOoo: 'Chargement...',
                noRowsToShow: 'Aucune ligne à afficher',
                to: 'à',
                of: 'sur',
                more: '...',
                pinColumn: 'Épingler',
                pinLeft: 'Épingler à gauche',
                pinRight: 'Épingler à droite',
                noPin: 'Ne pas épingler',
                autosizeThiscolumn: 'Redimensionner cette colonne',
                autosizeAllColumns: 'Redimensionner toutes les colonnes',
                resetColumns: 'Réinitialiser colonnes',
                filterOoo: 'Filtre...',
                contains: 'Contient',
                notContains: 'Ne contient pas',
                startsWith: 'Commence par',
                endsWith: 'Termine par',
                equals: 'Égal',
                notEqual: 'Non égal',
                searchOoo: 'Rechercher...',
                andCondition: 'ET',
                orCondition: 'OU',
                lessThan: 'Moins que',
                lessThanOrEqual: 'Moins que ou égal',
                greaterThan: 'Plus que',
                greaterThanOrEqual: 'Plus que ou égal',
                inRange: 'Compris entre',
                inRangeStart: 'De',
                inRangeEnd: 'à'
            },
            onFilterChanged: function() {
                const filters = this.api.getFilterModel();
                let filtersObject = [];

                for (let key of Object.keys(filters)) {
                    let filterParam = this.api.getFilterInstance(key).textFilterParams ?? this.api.getFilterInstance(key).numberFilterParams ?? this.api.getFilterInstance(key).dateFilterParams;

                    let field = filterParam.colDef.field ?? filterParam.colDef.cellRendererParams?.field;

                    if (field != null || filterParam?.colDef?.customFilter != null) {
                        filtersObject.push({
                            field: filterParam?.colDef?.customFilter ?? field,
                            operator: filters[key].operator,
                            conditions: filters[key].operator ? [filters[key].condition1, filters[key].condition2] : [filters[key]]
                        });
                    }
                }

                if (that.aggridApiParams == null) that.aggridApiParams = {};
                that.aggridApiParams = Object.assign(that.aggridApiParams, {filters: JSON.stringify(filtersObject)});
            }
        }

        if (this.gridOptions !== null) {
            this.gridMergedOptions = {
                ...this.gridMergedOptions,
                ...this.gridOptions
            };
        }

        this.gridReady = false;
    },
    mounted() {
        this.emitter.on('ag-grid-reload', this.reload);
    },
    unmounted() {
        this.emitter.off('ag-grid-reload', this.reload);
    },
    methods: {
        onGridReady(params) {
            this.gridReady = true
            this.gridApi = params.api;

            // Activer le tri uniquement sur les colonnes qui ont un field valide
            let columnDefs = this.gridApi.getColumnDefs();
            columnDefs.forEach(col => {
                if (col.field && col.sortable === undefined) {
                    col.sortable = true;
                }
            });
            this.gridApi.setColumnDefs(columnDefs);

            this.gridApi.setDatasource({
                rowCount: undefined,
                getRows: (params) => {
                    this.loaders.push(this.$loading.show({
                        'background-color': '#000000',
                        'color': '#FFFFFF'
                    }));

                    this.parameters = params;
                    this.paginationParams.page = params.endRow / this.numberItems;

                    this.launchRequest((response) => {
                        setTimeout(() => {
                            params.successCallback(response.data.data, response.data.totalRecords);

                            this.aggridCssProps = {
                                height: 50 + (70 * this.gridApi.getDisplayedRowCount()) + 'px'
                            };

                            if (this.loaders.length > 0) {
                                for (let loader of this.loaders) {
                                    loader.hide();
                                }
                                this.loaders = [];
                            }
                        }, 100);
                    });
                }
            });

            this.loadAggridArrangement();
        },
        onRowClicked: function(row) {
            if (($(row.event.target).hasClass('ag-cell') || $(row.event.target).is('span') || $(row.event.target).is('div')) && !($(row.event.target).hasClass('badge-messages'))) {
                this.$emit("rowClicked", row.data)
            }
        },
        getContextMenuItems(params) {
            let that = this;
            return [{
                name: 'Exporter en Excel',
                action: function () {
                    that.launchRequest((response) => {
                        that.getCSVFile(response.data.data);
                    }, true);
                },
                icon: '<span class="ag-icon ag-icon-excel" />',
            }];
        },
        launchRequest(callback, exportExcel = false) {
            let paginationParams = this.paginationParams;

            // Gestion de l'export Excel (limité pour éviter de surcharger le serveur)
            if (exportExcel) {
                paginationParams.page = 1;
                paginationParams.numberItems = this.exportLimit;
            }

            const columnDefs = this.gridApi.getColumnDefs();
            const fieldsSet = new Set(columnDefs.filter(c => c.field).map(c => c.field));
            const columnsSort = this.gridMergedOptions.columnApi.getColumnState().filter(column => column.sort !== null && fieldsSet.has(column.colId)).sort((a, b) => a.sortIndex < b.sortIndex ? -1 : 1);

            let sortObject = {};

            for (let columnSort of columnsSort) {
                sortObject[columnSort.colId] = columnSort.sort;
            }

            if (this.aggridApiParams === null) this.aggridApiParams = {};
            this.aggridApiParams = Object.assign(this.aggridApiParams, {sort: JSON.stringify(sortObject)});

            // Préparation du payload
            let payload = JSON.parse(JSON.stringify(this.paginationParams));

            let newApiParam = {};
            for (let apiParamKey in this.aggridApiParams) {
                if (this.aggridApiParams[apiParamKey] != null) {
                    newApiParam[apiParamKey] = this.aggridApiParams[apiParamKey]
                }
            }

            if (Object.keys(newApiParam).length !== 0) {
                payload = Object.assign(payload, newApiParam);
            }

            const params = new URLSearchParams(payload);

            // L'export peut viser une route dédiée, plus légère que celle de l'affichage
            const route = exportExcel && this.exportApiRoute ? this.exportApiRoute : this.apiRoute;

            let apiUrl = route + '?' + params;

            axios.get(apiUrl, {
                toastError: true
            })
            .then((response) => {
                callback(response);
            })
            .catch((error) => {
                console.log('error', error)
            });
        },
        reload() {
            this.gridApi.refreshInfiniteCache();
        },
        onColumnVisible() {
            this.saveAggridArrangement();
        },
        onSortChanged() {
            this.saveAggridSort();
        },
        onColumnResized(event) {
            if (event.finished) {
                this.saveAggridArrangement();
            }
        },
        getCSVFile(data) {
            let csvColumns = this.gridMergedOptions.columnApi.getColumnState().map(column => {
                let columnDetail = this.gridMergedOptions.columnApi.getColumn(column.colId);

                return {
                    id: columnDetail.colDef.cellRendererParams ? columnDetail.colDef.cellRendererParams.field : columnDetail.colDef.field,
                    name: columnDetail.colDef.headerName,
                    mode: columnDetail.colDef.cellRendererParams?.mode,
                    callback: columnDetail.colDef.cellRenderer,
                    valueFormatter: columnDetail.colDef.valueFormatter
                }
            });

            let rows = [];

            let line = csvColumns.map(csvColumn => csvColumn.name);
            rows.push(line);

            for (let currentData of data) {
                line = csvColumns.map(csvColumn => {
                    let cell = '';
                    let value = csvColumn.id != null ? csvColumn.id.split('.').reduce((p,c)=>p == null ? null : (p[c] ?? null), currentData) : null;

                    if (typeof csvColumn.callback === 'function') {
                        let callbackResult = csvColumn.callback({
                            data: currentData
                        });
                        // Si le callback retourne une string, on l'utilise directement
                        // Sinon (VNode ou autre), on utilise la valeur brute
                        if (typeof callbackResult === 'string') {
                            let span = document.createElement('span');
                            span.innerHTML = callbackResult.replace(/<br\s*\/?>/gi, ' ');
                            cell = (span.textContent || span.innerText).replace(/(\r\n|\n|\r)/gm, ' ');
                        } else {
                            // Pour les VNodes ou autres, utiliser la valeur brute de la colonne
                            cell = value;
                        }
                    } else if (typeof csvColumn.valueFormatter === 'function') {
                        cell = csvColumn.valueFormatter({ data: currentData, value: value }) ?? '';
                    } else {
                       switch (csvColumn.mode) {
                            case 'boolean':
                                cell = value ? 'Oui' : 'Non';
                            break;
                            case 'status':
                                cell = this.$store.getters.getAffairStatusList[value]?.label;
                            break;
                            case 'customerStatus':
                                cell = this.$store.getters.getAffairStatusList[value].customerLabel;
                            break;
                            default:
                                cell = value
                            break;
                        }
                    }

                    if (cell != null && typeof cell === 'string') {
                        cell = cell.replace(/\s\s+/g, ' ').trim();
                    } else if (cell != null && typeof cell !== 'string') {
                        cell = String(cell);
                    }

                    return this.getCSVCell(cell, value);
                });
                rows.push(line);
            }

            let csvContent = rows.map(e => e.join(";")).join("\n");

            this.exportCSV(csvContent, 'export_excel');
        },
        // Prépare une cellule pour le CSV : les colonnes numériques (montants, quantités...)
        // sont exportées en nombre pour rester additionnables dans Excel, les autres sont échappées
        getCSVCell(cell, value) {
            let numericCell = this.getCSVNumericCell(cell, value);
            if (numericCell !== null) return numericCell;

            let text = cell == null ? '' : String(cell);

            return /[";\r\n]/.test(text) ? '"' + text.replace(/"/g, '""') + '"' : text;
        },
        // Retourne la valeur numérique d'une cellule au format attendu par Excel en français
        // (séparateur décimal ',' et sans symbole monétaire), ou null si la cellule n'est pas un nombre
        getCSVNumericCell(cell, value) {
            if (value == null || value === '' || typeof value === 'boolean') return null;

            let number = Number(typeof value === 'string' ? value.trim().replace(',', '.') : value);
            if (typeof number !== 'number' || !isFinite(number)) return null;

            let text = (cell == null ? '' : String(cell)).trim();
            if (text === '') return null;

            // Une cellule numérique ne contient que des chiffres et de la décoration (€, %, séparateurs)
            if (/[^\d\s.,+\-€%]/.test(text)) return null;

            // On conserve le texte pour les identifiants (zéros de tête, numéros très longs)
            if (/^[+-]?0\d/.test(text) || text.replace(/\D/g, '').length > 15) return null;

            // On vérifie que le texte affiché correspond bien à la valeur brute
            // (sinon la colonne affiche autre chose que son nombre : statut, libellé...)
            let displayed = Number(text
                .replace(/[^\d.,+\-]/g, '')
                .replace(/\.(?=\d{3}(\D|$))/g, '')
                .replace(',', '.'));
            if (!isFinite(displayed) || Math.abs(displayed - number) > 0.005) return null;

            return String(number).replace('.', ',');
        },
        saveAggridArrangement() {
            // On récupère l'ensemble des colonnes
            const Column_Defs = this.gridApi.getColumnDefs();
            let columns = Column_Defs.map(column => column.field).join('_');

            // On génère une clé unique à partir de la route et du tableau
            let saveId = this.getUniqueSaveId(document.location.pathname + columns);
            // On enregistre dans le local storage les préférences d'affichage
            let aggridSave = JSON.parse(localStorage.getItem('aggridSave')) || {};
            aggridSave[saveId] = Column_Defs;
            localStorage.setItem('aggridSave', JSON.stringify(aggridSave));

            // Sauvegarder les largeurs de colonnes via getColumnState()
            let aggridWidthSave = JSON.parse(localStorage.getItem('aggridWidthSave')) || {};
            aggridWidthSave[saveId] = this.gridMergedOptions.columnApi.getColumnState().map(col => ({
                colId: col.colId,
                width: col.width
            }));
            localStorage.setItem('aggridWidthSave', JSON.stringify(aggridWidthSave));
        },
        saveAggridSort() {
            // On récupère l'ensemble des colonnes
            const Column_Defs = this.gridApi.getColumnDefs();
            let columns = Column_Defs.map(column => column.field).join('_');

            let sortSaveId = this.getUniqueSaveId(document.location.pathname + columns)
            let aggridSortSave = JSON.parse(localStorage.getItem('aggridSortSave')) || {};

            if (aggridSortSave[sortSaveId] == null) aggridSortSave[sortSaveId] = {}

            this.gridMergedOptions.columnApi.getColumnState().map(column => {
                if (column.sort !== null) {
                    if (!Object.keys(aggridSortSave[sortSaveId]).includes(column.colId)) aggridSortSave[sortSaveId] = {};
                    aggridSortSave[sortSaveId][column.colId] = {
                        sort: column.sort,
                        sorIndex: column.sortIndex
                    }
                } else {
                    delete aggridSortSave[sortSaveId]?.[column.colId]
                }
            });

            localStorage.setItem('aggridSortSave', JSON.stringify(aggridSortSave));
        },
        loadAggridArrangement() {
            // On récupère l'ensemble des colonnes
            let columns = this.gridApi.getColumnDefs().map(column => column.field).join('_');

            // On récupère la clé unique à partir de la route et du tableau
            let saveId = this.getUniqueSaveId(document.location.pathname + columns);
            let aggridSave = JSON.parse(localStorage.getItem('aggridSave') || null) || {};

            let sortSaveId = this.getUniqueSaveId(document.location.pathname + columns);
            let aggridSortSave = JSON.parse(localStorage.getItem('aggridSortSave') || null) || {};

            let validFields = new Set(this.gridApi.getColumnDefs().filter(c => c.field).map(c => c.field));
            let columnSortSaved = aggridSortSave?.[sortSaveId] ? Object.keys(aggridSortSave?.[sortSaveId])?.filter(k => validFields.has(k))?.[0] : null;

            // Si on a une sauvegarde, on l'applique
            if (aggridSave[saveId]) {
                let currentAggridArrangement = this.gridApi.getColumnDefs();
                let keyCurrentAggridArrangement = currentAggridArrangement.map(column => {
                    return column.field ?? (typeof column.cellRenderer === 'string' ? column.cellRenderer : column.headerName)
                }).join('_');

                let keySaveAggridArrangement = aggridSave[saveId].map(column => {
                    return column.field ?? (typeof column.cellRenderer === 'string' ? column.cellRenderer : column.headerName)
                }).join('_');

                // Si les clés sont identiques, c'est que côté développement on a pas ajouté/modifié les colonnes. Dans le cas contraire on ne peut pas recharger
                if (keyCurrentAggridArrangement === keySaveAggridArrangement) {
                    this.gridApi.setColumnDefs(aggridSave[saveId]);
                }
            }

            let columnDefs = this.gridApi.getColumnDefs();
            columnDefs.forEach(columnDef => {
                columnDef.hasOwnProperty('cellRendererFunctionName') && this.cellRendererFunctions.has(columnDef.cellRendererFunctionName) && (columnDef.cellRenderer = this.cellRendererFunctions.get(columnDef.cellRendererFunctionName));
            });
            columnDefs.forEach(columnDef => {
                columnDef.hasOwnProperty('valueFormatterFunctionName') && this.valueFormatterFunctions.has(columnDef.valueFormatterFunctionName) && (columnDef.valueFormatter = this.valueFormatterFunctions.get(columnDef.valueFormatterFunctionName));
            });

            this.gridApi.setColumnDefs(columnDefs);

            this.gridMergedOptions.columnApi.getColumnState().forEach(column => {
                if (columnSortSaved && column.colId === columnSortSaved) {
                    this.gridMergedOptions.columnApi.applyColumnState({
                        state: [
                            {
                                colId: columnSortSaved,
                                sort: aggridSortSave[sortSaveId][columnSortSaved]?.sort,
                                sortIndex: aggridSortSave[sortSaveId][columnSortSaved]?.sortIndex,
                            }
                        ]
                    })
                }
            });

            // Restaurer les largeurs de colonnes sauvegardées
            let aggridWidthSave = JSON.parse(localStorage.getItem('aggridWidthSave') || null) || {};
            if (aggridWidthSave[saveId]) {
                this.gridMergedOptions.columnApi.applyColumnState({
                    state: aggridWidthSave[saveId],
                    applyOrder: false
                });
            }
        },
        getUniqueSaveId(str) {
            let hash = 0;
            for (let i = 0; i < str.length; i++) {
                hash  = ((hash << 5) - hash) + str.charCodeAt(i);
                hash |= 0;
            }
            return `save_${Math.abs(hash)}`;
        }
    }
  }
</script>
